module.exports = __webpack_public_path__ + "media/images/logos/subject-knowledge-bcs-e8f6147629ac7d4664b86ade484568ca.svg";